import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "You have several options: (i) you may simply reload your eGeeTouch® App to reassign a new passcode on your new phone, tag or smart devices. Then, use the App to disable or delete your old ID that resides in the eGeeTouch® lock which was previously paired with your lost phone, (ii) use your eGeeTouch® tag/fob/card to unlock. If you lost your tag, then simply purchase a new tag, pair it with your smartphone. (iii) For eGeeTouch® luggage lock, you may even use the user's backup key provided to gain access through the TSA master-key hole.",
    reply2:
      "These multiple options of regaining secured access of your smartlocks eliminate stressful concerns over any future unintended access from the lost smartphone/tag. Never worry about changing your lock cylinder or entire mechanical lock anymore!",
    back: "Back",
  },
  ja: {
    reply1:
      "いくつかのオプションがあります: (i) eGeeTouch® アプリをリロードするだけで、新しい電話、タグ、またはスマート デバイスに新しいパスコードを再割り当てできます。次に、アプリを使用して、紛失した携帯電話と以前にペアリングされていた eGeeTouch® ロックに保存されている古い ID を無効にするか削除します。(ii) eGeeTouch® タグ/フォブ/カードを使用してロックを解除します。タグを紛失した場合は、新しいタグを購入してスマートフォンとペアリングするだけです。 (iii) eGeeTouch® ラゲッジ ロックの場合、TSA マスター キー ホールを通じてアクセスするために提供されたユーザーのバックアップ キーを使用することもできます。",
    reply2:
      "スマートロックへの安全なアクセスを取り戻すためのこれらの複数のオプションにより、紛失したスマートフォン/タグからの将来の意図しないアクセスに対するストレスの多い懸念が解消されます。もうロックシリンダーや機械式ロック全体を交換する心配はありません。",
    back: "戻る",
  },
  es: {
    reply1:
      "Tiene varias opciones: (i) simplemente puede recargar su aplicación eGeeTouch® para reasignar un nuevo código de acceso en su nuevo teléfono, etiqueta o dispositivos inteligentes. Luego, use la aplicación para deshabilitar o eliminar su identificación anterior que reside en la candado eGeeTouch® que se emparejó previamente con su teléfono perdido, (ii) use su etiqueta/llavero/tarjeta eGeeTouch® para desbloquear. Si perdió su etiqueta, simplemente compre una nueva y vincúlela con su teléfono inteligente. (iii) Para el candado de equipaje eGeeTouch®, incluso puede usar la llave de respaldo proporcionada por el usuario para obtener acceso a través del orificio de la llave maestra de la TSA.",
    reply2:
      "Estas múltiples opciones para recuperar el acceso seguro a sus candados inteligentes eliminan las preocupaciones estresantes sobre cualquier acceso no deseado en el futuro desde el teléfono inteligente o la etiqueta perdidos. ¡Nunca más te preocupes por cambiar el cilindro de tu candado o la candado mecánica completa!",
    back: "Atrás",
  },
});

class Q11_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q11_component;
